import {
  CURRENCY,
  ONE_HUNDRED_PERCENT,
  PROMOTION_TYPES,
  PROMOTION_UNITS,
  USD
} from "rivals/shared/constants";
import { Promotion } from "rivals/shared/interfaces/Promotion";

export function formatCurrency(amount: number, currency = USD): string {
  return new Intl.NumberFormat(Intl.DateTimeFormat().resolvedOptions().locale, {
    currency,
    style: CURRENCY
  }).format(amount);
}

// TODO: https://griosf.atlassian.net/browse/RVLS-7859
export function getDiscount(price: number, promotion?: Promotion): number {
  if (!promotion) {
    return 0;
  }
  if (promotion.unit === PROMOTION_UNITS.AMOUNT) {
    return promotion.amount;
  } else if (promotion.unit === PROMOTION_UNITS.PERCENT) {
    // Calculate the discount and round it to two decimal places
    const discount = price * (promotion.amount / ONE_HUNDRED_PERCENT);
    return (
      Math.round((discount + Number.EPSILON) * ONE_HUNDRED_PERCENT) /
      ONE_HUNDRED_PERCENT
    );
  } else if (promotion.type === PROMOTION_TYPES.FREE_TRIAL) {
    return price;
  }
  return 0;
}
